import { Stack } from "@mui/material";
import { useUnit } from "effector-react";

import { $playerData } from "../store";
import type { ResourceObjects } from "../types/tokenValley";
import LabTabs from "./LabTabs";
import ResearchTabs from "./ResearchTabs";

export interface LabTypes {
  id: number;
  title: string;
  maxValue: number;
  value: number;
  type: ResourceObjects;
}

const Lab = () => {
  const [playerData] = useUnit([$playerData]);

  const day: LabTypes[] = [
    {
      id: 1,
      title: "TV tokens",
      maxValue: 100,
      value: playerData.player_resources["resource/token"] || 0,
      type: "resource/token",
    },
    {
      id: 2,
      title: "Iron",
      maxValue: 100,
      value: playerData.player_resources["resource/iron"] || 0,
      type: "resource/iron",
    },
    {
      id: 3,
      title: "Wheat",
      maxValue: 100,
      value: playerData.player_resources["resource/wheat"] || 0,
      type: "resource/wheat",
    },
    {
      id: 4,
      title: "Wood",
      maxValue: 100,
      value: playerData.player_resources["resource/wood"] || 0,
      type: "resource/wood",
    },
  ];

  const mill: LabTypes[] = [
    {
      id: 4,
      title: "Flour",
      maxValue: 100,
      value: playerData.player_resources["resource/flour"] || 0,
      type: "resource/flour",
    },
    {
      id: 5,
      title: "Bread",
      maxValue: 100,
      value: playerData.player_resources["resource/bread"] || 0,
      type: "resource/bread",
    },
    {
      id: 6,
      title: "Cattle",
      maxValue: 100,
      value: playerData.player_resources["resource/cattle"] || 0,
      type: "resource/cattle",
    },
    {
      id: 7,
      title: "Milk",
      maxValue: 100,
      value: playerData.player_resources["resource/cattle"] || 0,
      type: "resource/milk",
    },
    {
      id: 8,
      title: "Cheese",
      maxValue: 100,
      value: playerData.player_resources["resource/cheese"] || 0,
      type: "resource/cheese",
    },
  ];

  return (
    <Stack
      p={1}
      gap={2}
      pb={"250px"}
      height={"100dvh"}
      bgcolor={"secondary.bgQuestionPage"}
      sx={{
        overflowY: "scroll",
        overflowX: "hidden",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
      }}
    >
      <ResearchTabs />
      <LabTabs title={"Farm"} cards={day} />
      <LabTabs title={"Mill"} cards={mill} />
    </Stack>
  );
};

export default Lab;
